import { render, staticRenderFns } from "./detectionList.vue?vue&type=template&id=038c4c49&scoped=true"
import script from "./detectionList.vue?vue&type=script&lang=js"
export * from "./detectionList.vue?vue&type=script&lang=js"
import style0 from "./detectionList.vue?vue&type=style&index=0&id=038c4c49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c4c49",
  null
  
)

export default component.exports